import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'timeslot_kind_exception_guid': 'String!',
	'jobtitle_guid': '[String]',
};

export default gql(`
	mutation timeslot_kind_exception_to_jobtitles( ${ HelperGraphql.createFields( fields ) } ) {
	    timeslot_kind_exception_to_jobtitles( ${ HelperGraphql.createVariables( fields ) } ) {
	        jobtitles {
	            guid
	        }
	    }
	}
`);

